// import React, { useEffect, useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   TextField,
//   MenuItem,
// } from "@mui/material";
// import { FilterAltOutlined } from "@mui/icons-material";
// import { keyframes } from "@mui/system";
// import {
//   primaryDark,
//   accentColor,
//   buttonGradient,
//   buttonGradientHover,
// } from "../../../constants/consts";

// const popIn = keyframes`
//   from { opacity: 0; transform: scale(0.92); }
//   to   { opacity: 1; transform: scale(1); }
// `;

// const EMPTY = {
//   sunucuKodu: "",
//   personel: "",
//   durum: "",
//   contract: "",
//   startDate: "",
//   endDate: "",
// };

// export default function SupportFilterDialog({
//   open,
//   onClose,
//   onApply,
//   sunucuKoduList = [],
//   personelList = [],
// }) {
//   const [form, setForm] = useState(EMPTY);

//   useEffect(() => {
//     if (open) setForm(EMPTY);
//   }, [open]);

//   const handleChange = (k) => (e) =>
//     setForm((prev) => ({ ...prev, [k]: e.target.value }));

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       fullWidth
//       maxWidth="sm"
//       PaperProps={{
//         sx: {
//           borderRadius: 3,
//           animation: `${popIn} 0.25s cubic-bezier(0.22, 1, 0.36, 1) both`,
//           overflow: "hidden",
//         },
//       }}
//     >
//       <Box
//         sx={{
//           px: 3,
//           py: 1.75,
//           background: `linear-gradient(135deg, ${primaryDark} 0%, ${accentColor} 100%)`,
//         }}
//       >
//         <DialogTitle
//           sx={{
//             p: 0,
//             color: "#fff",
//             fontWeight: 700,
//             display: "flex",
//             alignItems: "center",
//             gap: 1,
//           }}
//         >
//           <FilterAltOutlined sx={{ fontSize: 20 }} />
//           Filtre Uygula
//         </DialogTitle>
//       </Box>

//       <DialogContent sx={{ pt: 3 }}>
//         <Box
//           sx={{
//             display: "grid",
//             gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
//             gap: 2,
//           }}
//         >
//           <TextField
//             label="Sunucu Kodu"
//             value={form.sunucuKodu}
//             onChange={handleChange("sunucuKodu")}
//             select
//             fullWidth
//             size="small"
//           >
//             <MenuItem value="">Tümü</MenuItem>
//             {sunucuKoduList.map((s) => (
//               <MenuItem key={s} value={s}>
//                 {s}
//               </MenuItem>
//             ))}
//           </TextField>

//           <TextField
//             label="Personel"
//             value={form.personel}
//             onChange={handleChange("personel")}
//             select
//             fullWidth
//             size="small"
//           >
//             <MenuItem value="">Tümü</MenuItem>
//             {personelList.map((p) => (
//               <MenuItem key={p} value={p}>
//                 {p}
//               </MenuItem>
//             ))}
//           </TextField>

//           <TextField
//             label="Durum"
//             value={form.durum}
//             onChange={handleChange("durum")}
//             select
//             fullWidth
//             size="small"
//           >
//             <MenuItem value="">Tümü</MenuItem>
//             <MenuItem value="işlemde">İşlemde</MenuItem>
//             <MenuItem value="Beklemede">Beklemede</MenuItem>
//             <MenuItem value="Gönderildi">Gönderildi</MenuItem>
//             <MenuItem value="Tamamlandı">Tamamlandı</MenuItem>
//           </TextField>

//           <TextField
//             label="Sözleşme"
//             value={form.contract}
//             onChange={handleChange("contract")}
//             select
//             fullWidth
//             size="small"
//           >
//             <MenuItem value="">Tümü</MenuItem>
//             <MenuItem value="yes">Sözleşmeli</MenuItem>
//             <MenuItem value="no">Sözleşmeli Değil</MenuItem>
//             <MenuItem value="new">Yeni</MenuItem>
//           </TextField>

//           <TextField
//             label="Başlangıç Tarihi"
//             type="date"
//             value={form.startDate}
//             onChange={handleChange("startDate")}
//             fullWidth
//             size="small"
//             InputLabelProps={{ shrink: true }}
//           />
//           <TextField
//             label="Bitiş Tarihi"
//             type="date"
//             value={form.endDate}
//             onChange={handleChange("endDate")}
//             fullWidth
//             size="small"
//             InputLabelProps={{ shrink: true }}
//           />
//         </Box>
//       </DialogContent>

//       <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
//         <Button
//           onClick={onClose}
//           variant="outlined"
//           sx={{ textTransform: "none", borderRadius: 2 }}
//         >
//           İptal
//         </Button>
//         <Button
//           onClick={() => {
//             onApply?.(form);
//             onClose?.();
//           }}
//           variant="contained"
//           sx={{
//             textTransform: "none",
//             borderRadius: 2,
//             fontWeight: 700,
//             background: buttonGradient,
//             "&:hover": { background: buttonGradientHover },
//           }}
//         >
//           Uygula
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }
import React, { useEffect, useMemo, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Autocomplete,
} from "@mui/material";
import { FilterAltOutlined } from "@mui/icons-material";
import { keyframes } from "@mui/system";
import {
  primaryDark,
  accentColor,
  buttonGradient,
  buttonGradientHover,
} from "../../../constants/consts";

const popIn = keyframes`
  from { opacity: 0; transform: scale(0.92); }
  to   { opacity: 1; transform: scale(1); }
`;

const EMPTY = {
  sunucuKodu: "",
  personel: "",
  durum: "",
  contract: "",
  startDate: "",
  endDate: "",
};

/* ─── Ortak input stilleri ─── */
const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 2,
    transition: "box-shadow 0.25s ease, background-color 0.25s ease",
    "&:hover": { backgroundColor: "rgba(4,87,129,0.02)" },
    "&.Mui-focused": {
      boxShadow: "0 0 0 4px rgba(4,87,129,0.10)",
    },
  },
};

/* Türkçe karakter normalize */
const normalize = (s = "") => String(s).toLocaleLowerCase("tr-TR").trim();

export default function SupportFilterDialog({
  open,
  onClose,
  onApply,
  sunucuKoduList = [],
  personelList = [],
}) {
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    if (open) setForm(EMPTY);
  }, [open]);

  const handleChange = (k, v) => setForm((prev) => ({ ...prev, [k]: v }));

  // Autocomplete filtre fonksiyonu — Türkçe uyumlu
  const filterFn = useMemo(
    () =>
      (options, { inputValue }) =>
        options.filter((opt) => normalize(opt).includes(normalize(inputValue))),
    [],
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          animation: `${popIn} 0.25s cubic-bezier(0.22, 1, 0.36, 1) both`,
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{
          px: 3,
          py: 1.75,
          background: `linear-gradient(135deg, ${primaryDark} 0%, ${accentColor} 100%)`,
        }}
      >
        <DialogTitle
          sx={{
            p: 0,
            color: "#fff",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <FilterAltOutlined sx={{ fontSize: 20 }} />
          Filtre Uygula
        </DialogTitle>
      </Box>

      <DialogContent sx={{ pt: 3 }}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: 2,
          }}
        >
          {/* Sunucu Kodu — yazıp ara, tıkla, seç */}
          <Autocomplete
            size="small"
            options={sunucuKoduList}
            value={form.sunucuKodu || null}
            onChange={(_, v) => handleChange("sunucuKodu", v || "")}
            filterOptions={filterFn}
            noOptionsText="Sonuç bulunamadı"
            renderInput={(params) => (
              <TextField
                {...params}
                label="Sunucu Kodu"
                placeholder="Yaz veya seç"
                sx={inputSx}
              />
            )}
          />

          {/* Personel */}
          <Autocomplete
            size="small"
            options={personelList}
            value={form.personel || null}
            onChange={(_, v) => handleChange("personel", v || "")}
            filterOptions={filterFn}
            noOptionsText="Sonuç bulunamadı"
            renderInput={(params) => (
              <TextField
                {...params}
                label="Personel"
                placeholder="Yaz veya seç"
                sx={inputSx}
              />
            )}
          />

          {/* Durum — sabit liste, ama yine Autocomplete */}
          <Autocomplete
            size="small"
            options={["işlemde", "Beklemede", "Gönderildi", "Tamamlandı"]}
            value={form.durum || null}
            onChange={(_, v) => handleChange("durum", v || "")}
            filterOptions={filterFn}
            noOptionsText="Sonuç bulunamadı"
            renderInput={(params) => (
              <TextField
                {...params}
                label="Durum"
                placeholder="Yaz veya seç"
                sx={inputSx}
              />
            )}
          />

          {/* Sözleşme */}
          <Autocomplete
            size="small"
            options={["yes", "no", "new"]}
            value={form.contract || null}
            onChange={(_, v) => handleChange("contract", v || "")}
            getOptionLabel={(opt) =>
              opt === "yes"
                ? "Sözleşmeli"
                : opt === "no"
                  ? "Sözleşmeli Değil"
                  : opt === "new"
                    ? "Yeni"
                    : ""
            }
            renderOption={(props, opt) => (
              <li {...props}>
                {opt === "yes"
                  ? "Sözleşmeli"
                  : opt === "no"
                    ? "Sözleşmeli Değil"
                    : "Yeni"}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Sözleşme"
                placeholder="Yaz veya seç"
                sx={inputSx}
              />
            )}
          />

          <TextField
            label="Başlangıç Tarihi"
            type="date"
            value={form.startDate}
            onChange={(e) => handleChange("startDate", e.target.value)}
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            sx={inputSx}
          />
          <TextField
            label="Bitiş Tarihi"
            type="date"
            value={form.endDate}
            onChange={(e) => handleChange("endDate", e.target.value)}
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            sx={inputSx}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            textTransform: "none",
            borderRadius: 2,
            "&:hover": { transform: "translateY(-1px)" },
          }}
        >
          İptal
        </Button>
        <Button
          onClick={() => {
            onApply?.(form);
            onClose?.();
          }}
          variant="contained"
          sx={{
            textTransform: "none",
            borderRadius: 2,
            fontWeight: 700,
            background: buttonGradient,
            transition: "transform 0.2s ease, background 0.2s ease",
            "&:hover": {
              background: buttonGradientHover,
              transform: "translateY(-1px)",
            },
            "&:active": { transform: "translateY(0) scale(0.98)" },
          }}
        >
          Uygula
        </Button>
      </DialogActions>
    </Dialog>
  );
}
